import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Info } from 'react-feather'

import { Page, Container, Flex } from '../components/common'
import Meta from '../components/Meta'
import Header from '../components/Header'
import AlertCard from '../components/AlertCard'

const Alerts = ({ alerts = [] }) => {
  return (
    <Page>
      <Helmet title='Alerts & Notifications' />
      <Meta title='Alerts & Notifications' />
      <Header small title='Alerts & Notifications' />
      {alerts.length ? (
        alerts.map(alert => (
          <AlertCard key={`AlertCard-${alert.id}`} {...alert} />
        ))
      ) : (
        <Container taCenter>
          <Flex alignCenter justifyCenter>
            <Info />
            <span style={{ margin: '0 0 0 1rem' }}>No alerts to show</span>
          </Flex>
        </Container>
      )}
    </Page>
  )
}

Alerts.propTypes = {
  alerts: PropTypes.array.isRequired
}

export default Alerts



// WEBPACK FOOTER //
// ./src/views/Alerts.js